angular.module('app').directive('advancedTable', ["NgTableParams", '$rootScope', '$timeout', '$filter', function(NgTableParams, $rootScopes, $timeout, $filter) {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            tableData: '=',
            tools: '=',
            actions: '=',
            updateRow: "=",
            ignoreColumns: "=",
            childTools: "=",
            pagination: "=",
            listFilterObject: "=",
            pageStatuses: "=",
            allowUpdateContainer: "=",
            isBlock: "=",
            onBlurContainer: "=",
            tableName: "=",
            defaultOrder: "=",
            isSavePressed: "=",
            labelColumnContainer: '=?',
            notSortable: '=?'
        },
        templateUrl: "views/advancedTable/main.html",
        link:function(scope){
            var translationPrefixes = {
                banners: "pages.header.",
                news: "pages.editPage.tab.",
                promo: "pages.editPage.tab.",
                backgrounds: "pages.editPage.tab.",
                categories: "pages.header.",
                pages: "pages.header.",
                pagesChild: "pages.editPage.tab.",
                users: "users.list.",
                popups: "popups.list.",
                payments: "payments.list.",
                casinoGames: "casinoGame.list.",
                casinoCategoryItems: "filters.list.",
                categoriesAndProvidersCategories: "hiddenGames.list.categories.",
                categoriesAndProvidersProviders: "hiddenGames.list.providers.",
                hiddenGamesCategories: "hiddenGames.list.categories.",
                hiddenGamesProviders: "hiddenGames.list.providers.",
                products: "products.header.",
                providers: "casinoProvider.list.",
                skinGames: "casinoGame.list.",
                skins: "skins.list.",
                games: "casinoGame.list."
            };
            scope.paginationDropDownToggle = true;
            if (scope.pagination) {
                var isContains = scope.pagination.limits.filter(function (item) {
                    return item.value === 99999999;
                }).length > 0;
                if (scope.pagination.totalItems < 1000 && !isContains) {
                    scope.pagination.limits.unshift({value : 99999999, key: 'pages.statuses.all'});
                }

            }
            scope.setSubTableFixedStyles = function(){
                var subTable = $(".subTable");
                var maxWidthEl = $("#tableWidth");
                function setSubTable() {
                    subTable.css({
                        "max-width": maxWidthEl.width(),
                        "transform": "translate3d(" + maxWidthEl.scrollLeft() + "px, 0, 0)"
                    });
                }
                $timeout(function() {
                    var scrollResizeHandlers = false;
                    setSubTable();
                    if(!scrollResizeHandlers){
                        $("#tableWidth").scroll(function(){
                            setSubTable();
                        });
                        $(window).resize(function(){
                            setSubTable();
                        });
                        $('article').eq(0).resize(function(){
                            setSubTable();
                        });
                        scrollResizeHandlers = true;
                    }
                });
            };
            
            scope.init = function () {
                scope.show = false;
                scope.cols = [];
                for (var key in scope.tableData[0]){
                    if(!scope.ignoreColumns || !scope.ignoreColumns[key]){
                        var temp = {
                            title: key.replace(/(?=[A-Z])|_|-/g, " "),
                        };
                        if (!scope.allowUpdateContainer && !scope.notSortable) {
                            temp.sortable = key;
                        }
                        if (scope.tableName) {
                            var prefix = translationPrefixes[scope.tableName];
                            if (prefix) {
                                var translation = $filter("translate")(prefix + key);
                                if(translation.indexOf(prefix) === -1){
                                    temp.title = translation;
                                }
                            }
                        }
                        scope.cols.push(temp);
                    }
                }
                if(scope.tableData.length > 0) {
                    if(scope.tools) {
                        var temp = {
                            title: $filter("translate")('Tools'),
                            class: 'tools-cell sticky right pointer-events-none'
                        };
                        scope.cols.push(temp);
                    }
                    if(scope.actions) {
                        var temp = {
                            title: ' ',
                            class: 'actions-cell sticky left pointer-events-none'
                        };
                        scope.cols.unshift(temp);
                    }
                }
                var tableLength = scope.tableData.length;
                var tableParam = {
                    count: tableLength,
                    sorting: { name: "asc"}
                };
                if (scope.defaultOrder) {
                    tableParam = {
                        count: scope.tableData.length,
                        sorting: {}
                    };
                    tableParam.sorting[scope.defaultOrder] = "asc";
                }
                if (scope.allowUpdateContainer && !scope.notSortable) {
                    tableParam = {
                        count: scope.tableData.length
                    };
                }
                if (!scope.tooltip) {
                    scope.tooltip = {};
                }
                if (scope.isInEditMode && Object.keys(scope.tooltip).length === 0) {
                    for(var i = 0; i < tableLength; ++i){
                        scope.tooltip['pageTitle' + i] = "";
                        scope.tableData[i].index = i;
                    }
                }
                if (scope.showUpdateRow) {
                    var previousTooltip = angular.copy(scope.tooltip);
                    for(var i = 0; i < tableLength; ++i){
                        if (scope.tableData[i].addModel) {

                            if (Object.keys(previousTooltip).length > 0 && i >= 1){
                                scope.tooltip['pageTitle' + i] = previousTooltip['pageTitle' + (i - 1)];
                            }else {
                                scope.tooltip = scope.tooltip || {};
                                scope.tooltip['pageTitle' + i] = "";

                            }

                        } else {
                            if (i === Object.keys(previousTooltip).length) {
                                scope.tooltip = previousTooltip;
                            }
                            break;
                        }
                        scope.tableData[i].index = i;
                    }
                }
                if (scope.isBlock) {
                    var table = scope.tableData;
                    for(var i = tableLength; i--;){
                        if(table[i].name) {
                            table[i].name = $filter('translate')('pageNames.' + table[i].nameNoTrans);
                        }
                    }
                }
                if (scope.ignoreColumns) {
                    scope.ignoreColumns["index"] = true;
                }

                if (scope.childTools) {
                    for(var i = 0; i < tableLength; ++i){
                        var row = scope.tableData[i];
                        if (row.$selected && row.children) {
                            if (row.children.length > 0) {
                                var firstChild = row.children[0];

                                scope.childCols = [];
                                for(var name in firstChild){
                                    if (firstChild.hasOwnProperty(name) && !scope.ignoreColumns[name]) {
                                        var temp = {
                                            title: name.replace(/_|-/g, " "),
                                            sortable: name
                                        };
                                        var childPrefix = translationPrefixes["pagesChild"];
                                        if (childPrefix) {
                                            var trans = $filter("translate")(childPrefix + name);
                                            if(trans.indexOf(childPrefix) === -1){
                                                temp.title = trans;
                                            }
                                        }
                                        scope.childCols.push(temp);
                                    }
                                }
                                var temp = {
                                    title: 'Tools',
                                    class: 'tools-cell sticky right pointer-events-none'
                                };
                                scope.childCols.push(temp);
                                return;
                            }
                        }
                    }
                }
                scope.grid = new NgTableParams(tableParam, {
                    dataset: scope.tableData,
                    paginationMaxBlocks: 8,
                    counts: [10, 20, 30]
                });


            };


            scope.$watch('tableData', function(newVal, oldVal){
                if(newVal !== oldVal) {
                    scope.init()
                }
            });

            /**
             * Remove editing row
             */
            scope.removeEditRow = function removeEditRow(){
                scope.showUpdateRow = false;
                scope.tableData.splice(0, 1);
                $rootScope.broadcast("removedEditRow");
            };


            scope.$on("showUpdateRow", function(event, data){
                if (!scope.showUpdateRow) {
                    scope.tooltip = {};
                }
                scope.showUpdateRow = data;
                scope.init();
            });

            scope.$on("changeToEditMode", function(event, data){
                if (!scope.isInEditMode) {
                    scope.tooltip = {};
                }
                scope.isInEditMode = data;
                scope.init();
            });

            scope.$on("updateTable", function(event, data){
                scope.init();
            });
            scope.init();
            /**
             * auto set when change fromColumn set to column
             * @param model
             * @param fromColumn
             * @param toColumn
             */
            scope.autoSet = function autoSet(model, fromColumn, toColumn) {
                model[toColumn] = $filter("translate")('pageNames.' + model[fromColumn]);
            }


        }
    };


}]);
